import { DirectoryModel } from './directory-model.model';

export class RenameFileOrDir {
    dof: DirectoryModel;
    newName: string;
    language: string;

    constructor(dof: DirectoryModel, newName: string, language: string) {
        this.dof = dof;
        this.newName = newName;
        this.language = language;
    }
}
